import { render, staticRenderFns } from "./response_alert.vue?vue&type=template&id=20dfb3d8"
import script from "./response_alert.vue?vue&type=script&lang=js"
export * from "./response_alert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports